import { _ as __rest } from '../tslib.es6-C8rd5pYo.mjs';
import { clsx } from 'clsx';
import React from 'react';
import { Description } from '../Description/Description.es.js';
import { ErrorMessage } from '../ErrorMessage/ErrorMessage.es.js';
import { Label } from '../Label/Label.es.js';
import { CheckboxGroup as CheckboxGroup$1 } from 'react-aria-components';

const checkboxGroup = "_checkbox-group_1z9pi_1";
const optionsWrapper = "_options-wrapper_1z9pi_9";
const styles = {
	checkboxGroup: checkboxGroup,
	optionsWrapper: optionsWrapper
};

const CheckboxGroup = (_a) => {
  var { children, className, label, description, errorMessage, isRequired } = _a, props = __rest(_a, ["children", "className", "label", "description", "errorMessage", "isRequired"]);
  return React.createElement(
    CheckboxGroup$1,
    Object.assign({ className: clsx(className, styles.checkboxGroup), "data-zds": true }, props),
    label && React.createElement(Label, { isRequired }, label),
    React.createElement("div", { className: styles.optionsWrapper }, children),
    description && React.createElement(Description, null, description),
    React.createElement(ErrorMessage, null, errorMessage)
  );
};

export { CheckboxGroup };
//# sourceMappingURL=CheckboxGroup.es.js.map
